module.exports = __webpack_public_path__ + "img/6.f5112386.jpg";